import LibPhoneInput from 'react-phone-number-input';
import styled from 'styled-components';

const PhoneInput = styled(LibPhoneInput)`
  & input {
    line-height: 28px;
    clear: both;
    text-align: inherit;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #d8d8d8;
    box-shadow: none;
    box-sizing: border-box;
    color: #363636;
    display: inline-flex;
    font-family: ${({ theme }) => theme.fonts.text};
    width: 100%;
    -webkit-box-pack: start;
    justify-content: flex-start;
    padding: 0.5em 0.75em;
    position: relative;
    transition: all 0.3s;
    vertical-align: top;
    border-radius: 8px;
    font-size: 16px;
  }
`;

export default PhoneInput;
